
import * as React from 'react';
import { ConfigProvider, Spin } from 'antd';
import { CoreLayout } from './layouts/coreLayout';
import { PersistGate } from 'redux-persist/integration/react';
import { cspNonce } from '@/nonceSetup';
import { persistor } from './app';
import { useAppSelector } from '@/types/reduxHelpers';
import { useFormValidateMessages } from '@/hooks/useFormValidateMessages';

export const AppWrapper: React.FC = (props) => {

    const validateMessages = useFormValidateMessages();
    const antdLocale = useAppSelector((state) => state.locale.antdLocale);

    return (
        <PersistGate
            loading={<Spin />}
            persistor={persistor}
        >
            <div style={{ height: '100%' }}>
                <ConfigProvider
                    form={{ validateMessages: validateMessages }}
                    locale={antdLocale}
                    componentSize="large"
                    autoInsertSpaceInButton={true}
                    csp={{
                        nonce: cspNonce,
                    }}
                >
                    <CoreLayout />
                </ConfigProvider>

            </div>
        </PersistGate>

    );
};